import React from 'react';
import '../gaic-styles.css';
import { NavLink } from 'react-router-dom';

const Footer = () => (
    <footer className="footer">
        <p>© 2024 GAIC Lab. All Rights Reserved.</p>
        <footer className="footer-links">
            {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Join Us</a>| */}
            {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a> | */}
            <NavLink to="/contactus" activeClassName="active-link">Contact Us</NavLink>
            {/* <Route path="/contactus" element={<ContactUs />} /> */}
        </footer>
    </footer>
);

export default Footer;
